import clsx from "clsx"

import { Skeleton } from "@particles/index"

import useObjectCard from "@molecules/ObjectCard/ObjectCard.context"

import styles from "./ObjectCardFooter.module.scss"
import { ObjectCardFooterProps } from "./ObjectCardFooter.types"

export default function ObjectCardFooter(props: ObjectCardFooterProps) {
    const { children, className } = props

    const { isLoading } = useObjectCard()

    if (isLoading) {
        return (
            <div className={clsx(styles.base, className)}>
                <Skeleton height={32} />
            </div>
        )
    } else {
        return <div className={clsx(styles.base, className)}>{children}</div>
    }
}
